import listContract from './listContract'
import createContract from './createContract'
import fetchContractById from './fetchContractById'
import updateContract from './updateContract'
import deleteContract from './deleteContract'
import activateContract from './activateContract'

//
import axios from 'axios'
import ContractModel from '@/models/HumanResource/HrContract'

/**
 * 
 */
const fetchById = async id => {
    try {
        const response = await axios.get( process.env.VUE_APP_API_ROUTE + '/hr_contract/' + id + '?include=hr_contract_asset_discount&bypass=true' )
        return response.data
    } catch ( error ) {
        return error.response.data
    }
}

/**
 * 
 */
const fetchBy = async ( key, value ) => {

    //
    try {

        //
        const response = await ContractModel.where( key, value ).get()

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default {
    fetchById,
    listContract,
    createContract,
    fetchContractById,
    fetchBy,
    updateContract,
    deleteContract,
    activateContract,
}
